<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-modal.modal-filter-outgoing
            variant="primary"
          >
            <feather-icon icon="FilterIcon" class="mr-25" />
            <span>Filter</span>
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3" />
        <b-col md="3">
          <b-form-input v-model="filter" type="search" placeholder="search" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            striped
            :items="items"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            caption-top
            :responsive="true"
          >
            <template #table-caption>
              <h2>Outgoing Messages</h2>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
          />
        </b-col>
      </b-row>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>

    <b-col>
      <b-modal
        id="modal-filter-outgoing"
        ref="modal"
        hide-footer
        title="Filter OutGoing messages"
        size="lg"
      >
        <validation-observer ref="simpleRules">
          <form ref="form" @submit.stop.prevent="filterOutgoingMessage">
            <b-row>
              <b-col md="6">
                <b-form-group label="Order Code" label-for="orderCode">
                  <b-form-input
                    id="orderCode-input"
                    v-model="filterForm.orderCode"
                    placeholder="orderCode"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Message Type" label-for="messageType">
                  <validation-provider
                    #default="{ errors }"
                    name="messageType"
                    rules="required"
                  >
                    <!-- <v-select
                      v-model="filterForm.messageType"
                      label="text"
                      :options="messageTypeOptions"
                    /> -->
                    <b-form-select
                      v-model="filterForm.messageType"
                      :options="messageTypeOptions"
                      size="sm"
                      class="mt-1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Provider Id" label-for="providerId">
                  <b-form-input
                    id="providerId-input"
                    v-model="filterForm.providerId"
                    placeholder="providerId"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Partner Type" label-for="partnerType">
                  <validation-provider
                    #default="{ errors }"
                    name="partnerType"
                    rules="required"
                  >
                    <!-- <v-select
                      v-model="filterForm.partnerType"
                      label="text"
                      :options="messageTypeOptions"
                    /> -->
                    <b-form-select
                      v-model="filterForm.partnerType"
                      :options="partnerTypeoption"
                      size="sm"
                      class="mt-1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Transaction Date Range"
                  label-for="OutgoingMessageDateRange"
                >
                  <flat-pickr
                    v-model="OutgoingMessageDateRange"
                    class="form-control"
                    :config="{ mode: 'range' }"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-button
              variant="primary"
              type="submit"
              @click.prevent="filterOutgoingMessage"
            >
              Filter
            </b-button>
          </form>
        </validation-observer>
      </b-modal>
    </b-col>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BCard,
  BOverlay,
  BButton,
  BFormGroup,
  BFormSelect,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import axios from "@axios";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BCard,
    BOverlay,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    flatPickr,
    BFormSelect,
  },
  data() {
    return {
      required,
      isLoading: false,
      props: ["items"],
      fields: [
        "orderCode",
        "merchantName",
        "paymentOptionName",
        "providerName",
        "messageTypeDescription",
        "paidDateTime",
        "orderDate",
      ],
      items: [],
      filter: "",
      perPage: 10,
      currentPage: 1,
      OutgoingMessageDateRange: "",
      filterForm: {
        orderCode: "",
        providerId: "",
        fromDate: "",
        toDate: "",
        messageType: 0,
        partnerType: 0,
      },
      messageTypeOptions: [
        { value: 0, text: "All" },
        { value: 1, text: "ConfirmPayment" },
        { value: 2, text: "FetchOrder" },
        { value: 3, text: "OrderRequest" },
      ],
      partnerTypeoption: [
        { value: 0, text: "All" },
        { value: 1, text: "Bank" },
        { value: 2, text: "Merchant" },
        { value: 3, text: "PSP" },
      ],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.fetchData().catch((error) => {
      console.error(error);
    });
  },
  methods: {
    filterOutgoingMessage() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$refs.modal.hide();
          this.isLoading = true;
          const [from, to] = this.OutgoingMessageDateRange.split(" to ");
          this.filterForm.fromDate = from;
          this.filterForm.toDate = to;

          if (this.OutgoingMessageDateRange.includes("to")) {
            this.filterForm.fromDate = from;
            this.filterForm.toDate = to;
          } else {
            this.filterForm.fromDate = this.OutgoingMessageDateRange;
            this.filterForm.toDate = this.OutgoingMessageDateRange;
          }

          console.log(`from:${this.filterForm.fromDate}`);
          console.log(`to:${this.filterForm.toDate}`);

          axios
            .get(
              `/Monitor/api/V1.0/Monitor/FilterOutGoingFailedMessage?orderCode=${this.filterForm.orderCode}&messageType=${this.filterForm.messageType}&partnerType=${this.filterForm.partnerType}&fromDate=${this.filterForm.fromDate}&toDate=${this.filterForm.toDate}`
            )
            .then((res) => {
              console.log(res);
              this.items = res.outGoingFailedMessages;
              this.isLoading = false;
            })
            .catch((res) => {
              this.isLoading = false;
              this.$bvModal.msgBoxOk(`${res.data.message}`, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Outgoing-View");
      axios
        .get("/Monitor/api/V1.0/Monitor/GetOutGoingMessageFailed")
        .then((res) => {
          this.items = res.outGoingFailedMessages;
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
